import { render } from "./CreateFolderComponent.vue?vue&type=template&id=3ed497be&ts=true"
import script from "./CreateFolderComponent.vue?vue&type=script&lang=ts"
export * from "./CreateFolderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__